/* @generated */

// src/assets/ui-icon/line/person-leave.tsx
import * as React from "react";
var PersonLeaveLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M13.5 16.5h3.738l-1.029-1.07 1.082-1.04 2.75 2.86-2.75 2.86-1.082-1.04L17.24 18H13.5v-1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M5.5 14.75A2.753 2.753 0 0 1 8.25 12h5.5a2.746 2.746 0 0 1 2.12 1h1.75a4.25 4.25 0 0 0-3.72-2.489A4.817 4.817 0 0 0 14.5 8c0-2.542-1.276-4-3.5-4S7.5 5.458 7.5 8a4.821 4.821 0 0 0 .6 2.508A4.25 4.25 0 0 0 4 14.75V18h8v-1.5H5.5v-1.75ZM11 5.5c.931 0 2 .284 2 2.5s-1.069 2.5-2 2.5-2-.284-2-2.5 1.069-2.5 2-2.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  PersonLeaveLine
};
